<template>
    <div id="modal-delete-menu" class="modal fade show">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" @click="listItemDelete">
                            <i class="text-muted fas fa-trash icon-size"></i>
                            <span class="pl-2">{{listNm}}から削除</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: {
            listNm: String,
            act: String
        },
        data () {
            return {
                id: ""
            }
        },
        watch: {
            getListItemDeleteStatus (status) {
                if (status == 0) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$store.dispatch('delItemFromList', {
                        listItem: 'id',
                        pageId: this.id
                    })
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            ...mapGetters(['getListItemDeleteStatus'])
        },
        methods: {
            openThis (id) {
                this.id = id
                $('#modal-delete-menu').modal('show')
            },
            hideThis () {
                this.resetThis()
                $('#modal-delete-menu').modal('hide')
            },
            listItemDelete () {
                this.$store.dispatch('listItemDelete', {
                    url: this.act,
                    key: this.id
                })
            },
            resetThis () {
                this.id = ""
            }
        }
    }
</script>

<style>

</style>
